import { makeStyles } from 'tss-react/mui';

const useStylesGridItem: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  gridItemCardViewBlock: {
    width: 'calc(25% - 10px)',
    minHeight: 200,
    marginBottom: '20px !important',
    [theme.breakpoints.down('lg')]: {
      width: 'calc(50% - 10px)',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      minHeight: 0,
    },
  },
  gridItemCardViewBlockCompressed: {
    width: 'calc(50% - 10px)',
    [theme.breakpoints.down('lg')]: {
      width: '100%',
      minHeight: 0,
    },
  },
  gridItemCardViewBlockExtraCompressed: {
    width: '100%',
    minHeight: 0,
  },
}));

export default useStylesGridItem;
